export class IngFilter {
  pageNumber!: number
  pageSize!: number
  selectedId!: number
  searchText!: string
  wareHouseId!: number
}
export interface IngredListData {
  pageSize: number
  pageNumber: number
  totalCount: number
  warehouseName: string
  canAdd: boolean
  wareHouseIngredientDtos: PageData[]
}

export interface PageData {
  id: number|null
  wareHouseId: number|null
  ingredientId: number|null
  ingredientUnitId: number|null
  factor: number|null
  canEditIngredient: boolean
  canDeleteIngredient: boolean
  ingredient?: Ingredient|null
  ingredientUnit?: IngredientUnit|null
}

export interface Ingredient {
  id: number
  name: string
  title_EN: any
  title_AR: any
  icon: string
  categoryId: number
  numberOfUse: number
  created: any
  updated: any
  isDeleted: boolean
  canEdit: boolean
  canDelete: boolean
  categoryName: any
}

export interface IngredientUnit {
  id: number
  name: string
  title_EN: any
  title_AR: any
}


export enum CostPriceMethodEnum {
    Fixed = 'Fixed',
    FromTransactions = 'FromTransactions'
}